import { makeStyles } from '@material-ui/styles';
import MainButton from '../../buttons/MainButton';
import Text from '../../Text';

const useStyles = makeStyles(
    {
        wrap: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            minHeight: '100%',
            flexGrow: 4,
            '& > * + *': {
                marginTop: 16,
            },
        },
    },
    { classNamePrefix: 'error-page' }
);

const LoadingError: React.VFC = () => {
    const classes = useStyles();
    const onClickReload = () => location.reload();

    return (
        <div className={classes.wrap}>
            <Text variant="t20">Oops... something went wrong.</Text>
            <Text variant="t61">We encountered a problem while loading this page.</Text>
            <MainButton onClick={onClickReload}>Reload</MainButton>
        </div>
    );
};

export default LoadingError;
